import { ContractsContextlessPoliciesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type UseFetchContractsPermissionsType = {
  loading: boolean
  canSeeJobCatalog: boolean | null | undefined
}

export const useFetchContextlessContractsPermissions = (): UseFetchContractsPermissionsType => {
  const { data: policies, loading } = useQuery(ContractsContextlessPoliciesDocument)

  return {
    loading,
    canSeeJobCatalog: policies?.jobCatalog?._policies.seeJobCatalog.can,
  }
}
